import styled from "@emotion/styled";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import { RightArrows } from "./RightArrows";

interface Props {
	className?: string;
	title?: string;
	subTitle?: string;
	description?: string;
	img: string;
	linkTitle?: string;
	url?: string;
}

export const ImgCard = (props: Props) => {
	const navigate = useNavigate();

	return (
		<Container className={props.className} onClick={() => props.url && navigate(props.url)}>
			{props.title && <h3 className='i-top'>{props.title}</h3>}
			{props.subTitle && <h4 className='i-sub' >{props.subTitle ?? "" }</h4>}
			<div>
				<Image src={props.img} preview={false} width='100%' />
			</div>
			{props.linkTitle && (
				<div className='button'>
					<span>{props.linkTitle}</span>
					<RightArrows />
				</div>
			)}
			{props.description && <div className='i-description' dangerouslySetInnerHTML={{ __html: props.description ?? "" }} />}
		</Container>
	);
};
const Container = styled.div`
	margin-top: 15px;
	cursor: pointer;

	.i-top {
		background: #004885;
		width: 100%;
		padding: 3rem 0.5rem 0.5rem;
		color: white;
		font-weight: 500;
		margin-bottom: 0.5rem;
	}

	.i-description {
		font-size: 14px;
		margin-bottom: 0.5rem;
		min-height: 50px;
	}

	.button {
		color: #004885;
		border: 1px solid #e9eae9;
		padding: 1rem;
		position: relative;
		text-decoration: none !important;
		font-size: 14px;
		line-height: 14px;
		display: flex;
		justify-content: space-between;

		.action {
			line-height: 19px;
		}
	}
`;
